import { render, staticRenderFns } from "./ViewStocktakeSidebar.vue?vue&type=template&id=608623b6&scoped=true&"
import script from "./ViewStocktakeSidebar.vue?vue&type=script&lang=js&"
export * from "./ViewStocktakeSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ViewStocktakeSidebar.vue?vue&type=style&index=0&id=608623b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608623b6",
  null
  
)

export default component.exports